/* EDIT SOFTSKILL ABILITY */
export const EDIT_SOFTSKILL_ABILITY = "EDIT_SOFTSKILL_ABILITY"
export const EDIT_SOFTSKILL_ABILITY_SUCCESS = "EDIT_SOFTSKILL_ABILITY_SUCCESS"
export const EDIT_SOFTSKILL_ABILITY_CLEAN = "EDIT_SOFTSKILL_ABILITY_CLEAN"
export const EDIT_SOFTSKILL_ABILITY_ERROR = "EDIT_SOFTSKILL_ABILITY_ERROR"
